import { createDefaultInstanceGetter } from '@/stores/utils';

export class CompositeLiveStore {}

export const getDefaultCompositeLiveStore = createDefaultInstanceGetter(
    CompositeLiveStore,
);
